<template>
<section id="section-case" class="section appear" data-stellar-background-ratio="0.4">
			<div class="container">
				<div class="row">
					<div class="col-lg-12">
						<p class="center-block notransition animated fadeInUpNow animation103 align-center" style="color:white;font-size: 45px;margin:0">闲 暇 之 余</p>
					</div>
				</div>
			</div>
		</section>
</template>

<style>

</style>

<script>
export default {
  name: 'Case'
}
</script>